
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 質問管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" color="light" class="mx-2"><CLink :href="'/question/radio_import'" > 選択問題CSVインポート</CLink></CButton>
                  <CButton size="sm" color="light" class="mx-2"><CLink :href="'/question/import'" > まるばつ問題CSVインポート</CLink></CButton>
                  <CButton size="sm" color="info" @click="showRecordModal({}, 0, 'Create')">新規作成</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="2">
                </CCol>
                <CCol sm="4">
                </CCol>
                <CCol sm="2">
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="問題の種別"
                    :options="questionTypes"
                    v-model="select_type"
                    @update:value="search"
                    name="question_type"
                  />
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="業種"
                    :options="industryTypes"
                    v-model="select_industry"
                    @update:value="search"
                    name="industry_id"
                  />
                </CCol>
              </CRow>


              <CDataTable
                :hover="true"
                :striped="true"
                :items="questions"
                :fields="fields"
                :loading="isLoading"
                :itemsPerPage="40"
                :responsive="true"
                pagination
                :tableFilter="true"
                @update:table-filter-value="search"
                sorter
                @update:sorter-value="sort"
              >
                <template #title="{item}">
                  <td>
                    <CLink :href="'/questions/' + item.id" > {{ item.title }}</CLink>
                  </td>
                </template>
                <template #question_type="{item}">
                  <td>
                    {{ questionTypeLabel[item.question_type] }}
                  </td>
                </template>
                <template #industry_id="{item}">
                  <td> {{industries[item.industry_id]}}</td>
                </template>
                <template #midle_category="{item}">
                  <td>
                    <span v-if='item.midle_category != null'>
                      {{ item.midle_category }}
                    </span>
                  </td>
                </template>
                <template #updated_at="{item}">
                  <td> {{formatDate(item.updated_at)}}</td>
                </template>
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>
              </CDataTable>
              <CPagination
                :activePage.sync="page"
                :pages="meta.total_pages"
                align="center"
                @update:activePage="updatePageData"
              />



            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
      <question-modal  @hide="hideRecordModal()" :mode="mode" :record="record" :recordModal="recordModal" :industryTypes="industryTypes"></question-modal>
      <CModal
        title="削除しますか？"
        color="danger"
        :show.sync="deleteModal"
      >
        <div class="text-center">
          <p>この問題を削除しますか？？</p>
          <p>削除してしまうと復元することはできません</p>
        </div>
        <template #footer>
          <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
          <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
        </template>
      </CModal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import QuestionModal from "../../components/QuestionModal";
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {QuestionModal},
  data() {
    return {
      recordModal: false,
      deleteModal: false,
      isLoading: true,
      mode: "",
      record: {},
      filter_cs: [],
      filter_vs: [],
      questions: [],
      page: 1,
      word: "",
      meta: {},
      select_industry: "",
      select_type: "",
      industries: {},
      sort_column: "id",
      sort_asc: "desc",
      defaultContent: [
        {
            label: "",
            is_answer: false
        },
        {
            label: "",
            is_answer: false
        },
        {
            label: "",
            is_answer: false
        },
        {
            label: "",
            is_answer: false
        },

      ],
      fields: [
        { key: 'id', label: "ID"},
        { key: 'title', label: "問題文"},
        { key: 'question_type', label: "問題の種別"},
        { key: 'industry_id', label: "業種"},
        { key: 'midle_category', label: "中カテゴリー"},
        { key: 'answer', label: "回答"},
        { key: 'updated_at', label: "最終更新日"},
        { key: 'show_details',  label: '',  _style: 'width:15%', sorter: false, filter: false}],
      labelDic: {
          "username": "ユーザーEmailアドレス",
          "user_status": "ステータス",
          "enabled": "有効かどうか",
          "created_at": "作成日",
          "updated_at": "更新日"
      },
      questionTypeLabel: {
          "": "",
          "true_or_false": "丸ばつ問題",
          "radio": "単数選択式",
          "checkbox": "複数選択式",
      },
      questionTypes: [
         {
            value: "",
            label: "",
         },
         {
            value: "true_or_false",
            label: "丸ばつ問題",
         },
         {
            value: "radio",
            label: "単数選択式"
         },
         {
            value: "checkbox",
            label: "複数選択式"
         }
      ],
      state_options: [
        {value: "-", label: "-"},
        {value: "paied", label: "支払い済み"},
        {value: "unpaid", label: "未払い"}
      ],
      industryTypes: [] ,
      options: [],
      answer: false,
    }
  },
  validations: {
    record: {
      title: {required},
      question_type: {required},
      industry_id: {required},
      commentary: {required}
    }
  },
  methods: {
    isEmplty: function(str) {
        return (str == "")? true : false
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },

    sort: function(e) {
      this.sort_column = e.column
      this.sort_asc = (e.asc == true)? "asc" : "desc"
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/questions?word=" + this.word + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(","), {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.questions = response.data.questions
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/questions?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + n + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.questions = response.data.questions
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    search: function(e, c) {
      this.word = e
      if(c != undefined){
        this.filter_update(c.target.name, e)
      }
      if(e == "-") {
        this.word = ""
      }
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/questions?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.questions = response.data.questions
          this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    filter_update: function(k, v) {
      if(this.filter_cs.includes(k)) {
        var i = this.filter_cs.indexOf(k)
        if(v == "-") {
          this.filter_cs.splice(i, 1)
          this.filter_vs.splice(i, 1)
        } else {
          this.filter_cs[i] = k
          this.filter_vs[i] = v
        }
      } else {
        this.filter_cs.push(k)
        this.filter_vs.push(v)
      }
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規業種追加" : "編集"
    },
    updatePageData: function(n, e) {
      this.page = n
      console.log(e)
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/questions?page=" + n + "&word=" + this.word + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.questions = response.data.questions
          this.meta = response.data.meta
        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
    showRecordModal: function(i, index, mode="Edit") {
      this.record = {}
      this.recordModal = true
      this.record = i

      console.log(this.record)
      if(mode == "Edit") {
        this.record.content = (this.isEmplty(i.content))? JSON.parse("{}") : JSON.parse(i.content)
        this.options = this.record.content
      } else {
        this.options = this.defaultContent
      }

      this.mode = mode
      this.itemIndex = index
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else {
          return d
        }
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/questions/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.questions.splice(this.itemIndex, 1)
          this.deleteModal = false
        }).catch(error => {
          console.log(error)
        })
    },
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/questions", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        console.log(response)
          this.questions = response.data.questions
          this.meta = response.data.meta

          this.isLoading = false
      }).catch(error => {
          this.errorNotify(error.response)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.industryTypes = [{
              value: "",
              label: "",
          }]
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
      }).catch(error => {
          console.log(error)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>

<style scoped lang="scss">
.answer-form {
  padding: 5px 0px;
}

</style>

